import { render, staticRenderFns } from "./profile_nav.vue?vue&type=template&id=0d2fb1f8&scoped=true&"
import script from "./profile_nav.vue?vue&type=script&lang=js&"
export * from "./profile_nav.vue?vue&type=script&lang=js&"
import style0 from "./profile_nav.vue?vue&type=style&index=0&id=0d2fb1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fb1f8",
  null
  
)

export default component.exports